import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert,
  Link,
  Modal,
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import "../../../style/subAdmin/SubAdmin.scss";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import { getReport, getPayoutHistory } from "../../../redux/actions/reportAction";
import { getPayoutList } from "../../../redux/actions/payoutActions";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import DatePicker from "react-date-picker";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import moment from "moment";
import loader from "../../../style/loader/loader.scss";
import "../../../style/react-datetimepicker.scss";
import { CSVLink } from "react-csv";
import {aclUtil} from "../../util"

const history = createBrowserHistory();

const HorizontalLine = ({}) => <hr />;

const propTypes = {
  getReport: PropTypes.func.isRequired
};
let cityItems = [];
let isLoading = "false",
  csvData = [];
class MerchantPayoutPaid extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      menuKey: 'MERCHANT_PAIDPAYOUT_REPORT',
      path: ["Home", "Merchant Payout Paid Report"],
      links: ["home", "report/payout-paid"],
      date: new Date(),
      startDate: new Date(),
      range: false,
      disabled: false,
      isLoading: "false",
      csvData: "",
      reportData: "",
      historyPopup: false, 
      payoutHistory: '',
      offerIDs: '',
      merchantIDs: '',
      dealType: '',
      paymentTermID: '',
      payoutList: '',
    };

    this.validate = this.validate.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.Clear = this.Clear.bind(this);
    this.changeDatePicker = this.changeDatePicker.bind(this);
  }

  onChangeStartDate = date => this.setState({ startDate: date });
  onChangeStartDateRange = date => this.setState({ startDateRange: date });
  changeDatePicker = status => {
    if (this.state.range == false) {
      this.setState({ range: true });
    } else {
      this.setState({ range: false });
    }
  };

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleChange(e) {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ [e.target.name]: e.target.value });
  }

  validate = () => {
    let isError = false;
    const errors = {};
    return isError;
  };

  handleSubmit(e) {
    e.preventDefault();
    const err = this.validate();
    let formData;

    if (!err) {
      if (this.state.range == true) {
        let dateRange = this.state.startDateRange;
        formData = {
          startDate: moment(dateRange[0]).format('YYYY-MM-DD'),
          endDate: moment(dateRange[1]).format('YYYY-MM-DD'),
          offerIDs: this.state.offerIDs,
          merchantIDs: this.state.merchantIDs,
          dealType: this.state.dealType,
          paymentTermID: this.state.paymentTermID,
        };
      } else {
        formData = {
          startDate: moment(this.state.startDate).format('YYYY-MM-DD'),
          offerIDs: this.state.offerIDs,
          merchantIDs: this.state.merchantIDs,
          dealType: this.state.dealType,
          paymentTermID: this.state.paymentTermID,
        };
      }

      this.props.getReport(formData, 'report/merchant-paid-payout');
    }
  }

  Clear = () => {};

  handlePageChange = page => {};

  componentWillMount() {
    isLoading = "true";
    this.props.clearAlert();
    this.handleDismiss();
    this.props.getReport('', 'report/merchant-paid-payout')
    this.props.getPayoutList();
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    if(siteData) {
      if(siteData.combine_products == 'disable') {
        this.setState({dealType: 'offer'})
      }
    }
  }
  componentWillReceiveProps(nextProps) {

    if(!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)){
      this.context.router.history.push("/restrictedAccess");
    }

    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
        isLoading = "false";
      }
    }

    if (this.props.reportData !== nextProps.reportData) {
      if (nextProps.reportData) {
        isLoading = "false";
        this.setState({ reportData: nextProps.reportData });
        this.handleExport(nextProps.reportData);
      }
    }

    if (this.props.getpayoutSummary !== nextProps.getpayoutSummary) {
      if (nextProps.getpayoutSummary) {
        isLoading = "false";
        this.setState({ historyPopup: true, payoutHistory: nextProps.getpayoutSummary.data});
      }
    }

    if (nextProps.message) {
      this.handleShow();
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
    }

    if(this.props.payoutList !== nextProps.payoutList){
      if(nextProps.payoutList){
        isLoading="false";
        this.setState({payoutList: nextProps.payoutList.data})
      }
    }

  }

  handleExport = data => {
    let setDate = (this.state.range == true) ? moment(this.state.startDate).format('MM/DD/YYYY') +' - '+moment(this.state.endDate).format('MM/DD/YYYY') : moment(this.state.startDate).format('MM/DD/YYYY');
    csvData = [
      [
        'Type',
        'Merchant Name',
        'Offer ID',
        'Offer Name',
        'Payment Term',
        'Refund',
        'Gross Sales',
        'Net Payout',
        'Term Amount',
        'Amount Paid',
      ]
    ];

    {data &&
      data.data.map((data, index) =>
        csvData.push([
          (data.proposal_type == '10') ? 'Product' : (data.proposal_type == '11') ? 'Auction' : 'Offer',
          data.merchantName,
          data.OfferID,
          data.OfferName,
          data.paymentTerm,
          data.refundAmount,
          data.grossSales,
          data.netPayout,
          data.termAmount,
          data.amountRemaining,
        ])
      )
    }

    this.setState({ csvData: csvData });
  };

  paymentHistory = (e) => {
    let id = e.target.attributes.getNamedItem("data-key").value;
    let date = e.target.attributes.getNamedItem("data-date").value;
    isLoading = "true";
    this.props.getPayoutHistory({dueDate: date, dealID: id});
  }

  handleClose() {
    this.setState({
      historyPopup: false,
      payoutHistory: '',
    });
  }

  render() {
    return (
      <div className="col-lg-12 add-sub-admin">
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}

        <div className="row">
          <div className="col-xs-12">
            <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
          </div>
        </div>
        <form onSubmit={this.handleSubmit}>
          <div className="panel">
            <header className="panel-heading">Merchant Payout Paid Report</header>
            <div className="panel-body">
              <Row>
                <Col md={3} xs={12}>
                  <ControlLabel>Date</ControlLabel>
                  <FormGroup controlId="formOfferTitle">
                    {this.state.range == false ? (
                      <DatePicker
                        onChange={this.onChangeStartDate}
                        value={this.state.startDate}
                      />
                    ) : (
                      <DateRangePicker
                        onChange={this.onChangeStartDateRange}
                        value={this.state.startDateRange}
                      />
                    )}
                  </FormGroup>
                </Col>
                <Col md={3} xs={12}>
                  <FormGroup controlId="formParentID">
                  <ControlLabel>Deal Type</ControlLabel>
                    <FormControl
                      componentClass="select"
                      name="dealType"
                      onChange={this.handleChange}
                      placeholder="select"
                      value={this.state.dealType}
                      >
                      <option value="">All</option>
                      <option value="offer">Offer</option>
                      <option value="products">Products</option>
                      <option value="auction">Auction</option>
                    </FormControl>
                  </FormGroup>
                </Col>
                <Col md={3} xs={12}>
                  <FormGroup>
                    <ControlLabel>Deal IDs (separate by comma)</ControlLabel>
                    <FormControl
                        type="text"
                        name="offerIDs"
                        value={this.state.offerIDs}
                        onChange={this.handleChange}
                    />
                  </FormGroup>
                </Col>
                <Col md={3} xs={12}>
                  <FormGroup>
                    <ControlLabel>Merchant IDs (separate by comma)</ControlLabel>
                    <FormControl
                        type="text"
                        name="merchantIDs"
                        value={this.state.merchantIDs}
                        onChange={this.handleChange}
                    />
                  </FormGroup>
                </Col>
                <Col md={3} xs={12}>
                  <FormGroup>
                    <ControlLabel>Payment Term</ControlLabel>
                    <FormControl
                      componentClass="select"
                      name="paymentTermID"
                      onChange={this.handleChange}
                      value={this.state.paymentTermID}
                    >
                      <option value="">All</option>
                      {(this.state.payoutList !== '') &&
                        this.state.payoutList.data.map((data, index) =>
                          <option key={data.termID+index} value={data.termID}>{data.termName}</option>
                        )
                      }
                    </FormControl>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={12} xs={12}>
                  <Button
                    bsStyle="info"
                    type="submit"
                    id="saveButton"
                    disabled={this.state.disabled}
                  >
                    Submit
                  </Button>
                  {this.state.csvData ? (
                    <CSVLink
                      data={this.state.csvData}
                      filename={"merchantpayoutpaid-report.csv"}
                      className="btn btn-default"
                    >
                      Export CSV
                    </CSVLink>
                  ) : null}
                  {this.state.range == false ? (
                    <a
                      className="btn btn-success"
                      type="submit"
                      onClick={this.changeDatePicker}
                      id="saveButton"
                    >
                      Use Range
                    </a>
                  ) : (
                    <a
                      className="btn btn-success"
                      type="submit"
                      onClick={this.changeDatePicker}
                      id="saveButton"
                    >
                      Use Date
                    </a>
                  )}
                </Col>
              </Row>
            </div>
          </div>
        </form>
        {/**end contract information **/}

        <div className="panel">
          <div className="panel-body">
            <table className="table table-hover table-bordered">
              <thead>
                <tr>
                  <th>Type</th>
                  <th>Merchant Name</th>
                  <th>Offer ID</th>
                  <th>Offer Name</th>
                  <th>Payment Term</th>
                  <th>Refund</th>
                  <th>Gross Sales</th>
                  <th>Net Payout</th>
                  <th>Term Amount</th>
                  <th>Amount Paid</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
              {this.state.reportData ?
                    this.state.reportData.data.map((data, index) =>
                <tr key={data.scheduleID + index}>
                  <td>{(data.proposal_type == '10') ? 'Product' : (data.proposal_type == '11') ? 'Auction' : 'Offer'}</td>
                  <td>{data.merchantName}</td>
                  <td>{data.OfferID}</td>
                  <td>{data.OfferName}</td>
                  <td>{data.paymentTerm}</td>
                  <td>{data.refundAmount}</td>
                  <td>{data.grossSales}</td>
                  <td>{data.netPayout}</td>
                  <td>{data.termAmount}</td>
                  <td>{data.amountRemaining}</td>
                  <td><Button bsStyle="success" data-key={data.OfferID} data-date= {data.dueDate} onClick={this.paymentHistory}><i className="glyphicon glyphicon-eye-open"></i> View History</Button></td>
                </tr>
                )
                :
                <tr><td colSpan="13">Data Not Found</td></tr>
              }
              </tbody>
            </table>
          </div>
        </div>
        <Modal show={this.state.historyPopup} onHide={this.handleClose.bind(this)}>
          <Modal.Header closeButton>
            <Modal.Title>View History</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <table className="table table-hover table-bordered">
              <thead>
                <tr>
                  <th>Amount</th>
                  <th>Transaction ID</th>
                  <th>Comment</th>
                  <th>Paid Time</th>
                </tr>
              </thead>
              <tbody>
                {this.state.payoutHistory ?
                  this.state.payoutHistory.map((history, index) => 
                    <tr>
                      <td>{history.pay_amount}</td>
                      <td>{history.transaction_id}</td>
                      <td>{history.comment}</td>
                      <td>{moment(history.created_on).format('M-D-Y')}</td>
                    </tr>
                  )
                :
                <tr>
                  <td colSpan="2">Data Not Found</td>
                </tr>
                }
              </tbody>
            </table>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="danger" onClick={this.handleClose.bind(this)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    error: state.reportReducer.error,
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message,
    reportData: state.reportReducer.reportData,
    getpayoutSummary: state.reportReducer.getpayoutSummary,
    payoutList:  state.payoutReducer.payoutList,
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, {
    renderAlert,
    clearAlert,
    getReport,
    getPayoutHistory,
    getPayoutList
  })
)(MerchantPayoutPaid);



// WEBPACK FOOTER //
// ./src/app/views/admin/reports/MerchantPayoutPaid.js